// Keys whose values constitute PHI (HIPAA) — medical record data AND direct
// patient identifiers. Patient names were originally kept for triage; decided
// in #186 to scrub them too and triage on checkId / correlation tags instead
// (we have no BAA with Sentry, so nothing identifying may leave for it).
const MEDICAL_RECORD_KEYS = new Set([
  "firstname", "lastname", "middlename", "patientname",
  "dateofbirth", "dob", "birthdate",
  "memberid", "policynumber",
  "ssn", "socialsecurity",
  "benefits", "rawpayload", "rawpayloadmeta",
  "copay", "deductible", "coinsurance", "oopmax",
  "requestsubscriber", "subscriber",
  "bodypreview", "raw", "rawebcount",
  "benefitcount", "benefitscount",
]);

function isMedicalRecordKey(key: string): boolean {
  return MEDICAL_RECORD_KEYS.has(key.toLowerCase().replace(/[_\-.]/g, ""));
}

// Recurses through nested arrays (not just array-of-object) so a logged
// array-of-arrays — e.g. `console.log(patients)` on a list of rows wrapped
// again by Sentry's console breadcrumb `arguments` — doesn't pass its
// objects through unscrubbed.
function scrubArrayItems(arr: unknown[]): unknown[] {
  return arr.map(item =>
    Array.isArray(item)
      ? scrubArrayItems(item)
      : item && typeof item === "object"
        ? scrubMedicalData(item as Record<string, unknown>)
        : item
  );
}

export function scrubMedicalData(obj: Record<string, unknown>): Record<string, unknown> {
  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(obj)) {
    if (isMedicalRecordKey(key)) {
      result[key] = "[REDACTED]";
    } else if (Array.isArray(value)) {
      result[key] = scrubArrayItems(value);
    } else if (value && typeof value === "object") {
      result[key] = scrubMedicalData(value as Record<string, unknown>);
    } else {
      result[key] = value;
    }
  }
  return result;
}
